import { render, staticRenderFns } from "./WholeSaleGoodsItem.vue?vue&type=template&id=3160a90a&scoped=true"
import script from "./WholeSaleGoodsItem.vue?vue&type=script&lang=js"
export * from "./WholeSaleGoodsItem.vue?vue&type=script&lang=js"
import style0 from "./WholeSaleGoodsItem.vue?vue&type=style&index=0&id=3160a90a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3160a90a",
  null
  
)

export default component.exports